import SendEmailToVendor from '../SendEmailToVendor/SendEmailToVendor-Container'
import {
  AttachmentCommonUpload,
  Callout,
  Checkbox,
  EventHandler,
  InputField,
  Label,
  ModalPopup,
  PrimaryButton,
  SwitchToggle,
  Tooltip,
} from "../../../../CommonComponents";
import './VehicleRequestDetail.scss';
import { formatPrice } from "utils";
import { CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import ReloadIcon from '../../../../assets/images/Reload.svg';

interface IProps {
  assignTo?: any;
  accordionIndex?: any;
  orderDetails?: any;
  itemDetails?: any;
  isnonStandardequipment?: any;
  handleChange?: Function;
  handleChangeDropDown?: Function;
  purchaseOrderStepperData?: any;
  errors?: any;
  ismanagedequipment?: any;
  isvehiclerequestequipment?: any,
  activeStepper?: any,
  onCloseLinkAttachment?: any,
  onChangeLinkAttachment?: any,
  onClicktLinkAttachment?: any,
  isAttachmentBtnClicked?: any,
  getLinkedAttachmentsCount?: any,
  attachmentsList?: any
  linkedAttachment?: any
  assignedToError?: any
  check?: any
  onClickAttachment?: any
  savedStatus?: any,
  enableEditNSE?: any,
  editAssetInfo?: any,
  onChangePrice?: any,
  unitPriceFormat?: any
  isBulkOrder: boolean
  list?: any
  setList?: any
  uploadedList?: any
  onUploadClick?: any
  attachmentError?: any
  setAttachmentError?: any
  onRemoveClick: any
  autoSaveComments: Function
  onChnageQuoteAttached: (e: any, value: boolean) => void
  onClickSendPoToVendor?: any,
  showEmailPopup?: any,
  hidePopup?: any,
  handleClickTriggerEmail?: any,
  setSendEmailAttachmentsList?: any,
  sendEmailAttachmentsList?: any,
  setSendEmailList?: any,
  sendEmailList?: any,
  setEmailAttachmentError?: any,
  emailAttachmentError?: any,
  sendEmailError?: any,
  setSendEmailerror?: any,
  dismissMailAlert?: any,
  isEmailSentAlert?: any,
  isPoVendorEmailSent?: any,
  Popupcontent?: any,
  hideDialog?: any,
  popupOutlinebtnOnclick?: any,
  onClickViewPurchaseOrder?: any,
  onClickRefreshPurchaseOrder?: any
}
const ItemDetail = ({
  itemDetails,
  orderDetails,
  assignTo,
  accordionIndex,
  isnonStandardequipment,
  handleChange,
  handleChangeDropDown,
  purchaseOrderStepperData,
  errors,
  isvehiclerequestequipment,
  ismanagedequipment,
  activeStepper,
  onCloseLinkAttachment,
  onChangeLinkAttachment,
  onClicktLinkAttachment,
  isAttachmentBtnClicked,
  getLinkedAttachmentsCount,
  attachmentsList,
  linkedAttachment,
  assignedToError,
  check,
  onClickAttachment,
  savedStatus,
  enableEditNSE,
  editAssetInfo,
  onChangePrice,
  unitPriceFormat,
  isBulkOrder,
  list,
  setList,
  uploadedList,
  onUploadClick,
  attachmentError,
  setAttachmentError,
  onRemoveClick,
  autoSaveComments,
  onChnageQuoteAttached,
  onClickSendPoToVendor,
  showEmailPopup,
  hidePopup,
  handleClickTriggerEmail,
  setSendEmailAttachmentsList,
  sendEmailAttachmentsList,
  setSendEmailList,
  sendEmailList,
  setEmailAttachmentError,
  emailAttachmentError,
  setSendEmailerror,
  sendEmailError,
  dismissMailAlert,
  isEmailSentAlert,
  isPoVendorEmailSent,
  Popupcontent,
  hideDialog,
  popupOutlinebtnOnclick,
  onClickViewPurchaseOrder,
  onClickRefreshPurchaseOrder
}: IProps) => {
  let isRequisitionComplete = savedStatus?.filter((saveItem: any) => (saveItem?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId))?.[0]
  const getAttachmentView = (itemType: any, index: any) => {
    let val = itemType?.filter((item?: any) => item?.fleetItemId == purchaseOrderStepperData?.fleetRequestDetailId)
    return (
      <div className="tooltip-container">
        <div className='header'>
          <EventHandler onEvent={(e: any)=>onCloseLinkAttachment(e)} data-attribute="ItemDetail_Default_EventHandler_2">
            <img src="close" alt="" />
          </EventHandler>
        </div>
        <div className='content'>
          <div className="checkbox-list-container p-0">
            {
              attachmentsList?.length ? attachmentsList?.map((attachment: any) => {
                let isAlreadyExist = purchaseOrderStepperData?.attachments?.filter((item?: any) => (item?.fileName == attachment.fileName && !item?.isFleet))
                const extensionList = ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'txt', 'bmp', 'webp', 'pdf', 'xlsx', 'heif', 'hevc'];
                const indexExt = attachment?.fileName.lastIndexOf('.');
                const extension = attachment?.fileName.slice(indexExt + 1);
                return (
                  <div key={attachment?.fileName} className='checkbox-container'>
                    <Checkbox
                      className={"checkbox"}
                      disabled={isAlreadyExist?.length || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) ? true : false}
                      title={attachment?.fileName}
                      defaultChecked={isAlreadyExist?.length ? true : val ? val[0]?.attachments?.map((x: any) => x.fileName).includes(attachment.fileName) : false}
                      onChange={(e: any) => { onChangeLinkAttachment(e, attachment, val) }}
                     data-attribute="ItemDetail_Default_Checkbox" />
                    {extensionList.includes(extension.toString().toLowerCase()) ?
                      <EventHandler onEvent={() => { onClickAttachment(attachment?.attachmentUrl) }} data-attribute={`ItemDetail_${(attachment?.fileName || attachment?.attachmentUrl).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Attachment_EventHandler`}>
                        <div className='left-block'>
                          <a className='attachment-list'>{attachment?.fileName}</a>
                          <div className='pull-right'></div>
                        </div>
                      </EventHandler>
                      :
                      <div className='left-block'>
                        <a href={attachment?.attachmentUrl}>{attachment?.fileName}</a>
                        <div className='pull-right'></div>
                      </div>
                    }
                  </div>)
              }) :
                <div className='checkbox-container text-center'>
                  No Attachment
                </div>
            }
          </div>
        </div>
      </div>
    )
  }

  const commonFields = () => {
    return (<>
      <div className={`asset-block ${isvehiclerequestequipment ? itemDetails.orderRequestSubType === CONSTANTS?.PRODUCTION_VEHICLE ? 'production' : 'management' : (isnonStandardequipment ? 'non_standard_eqipment' : 'managed')}`}>
        <Label required className="mb-0" data-attribute="ItemDetail_Default_Label_23">Asset #</Label>
        <span>{purchaseOrderStepperData?.assetAfterSave ?? "-"}</span>
      </div>
      {!purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber') ?
        <>
          <div className={`vin-serial ${isvehiclerequestequipment ? itemDetails.orderRequestSubType === CONSTANTS?.PRODUCTION_VEHICLE ? 'production' : 'management' : (isnonStandardequipment ? 'non_standard_eqipment' : 'managed')}`}>
            <Label required className="mb-0" data-attribute="ItemDetail_Default_Label_2_2">Vin/Serial #</Label>
            <span>{purchaseOrderStepperData?.vinSerial ?? "-"}</span>
          </div>
          <div className={`po-number ${isvehiclerequestequipment ? itemDetails.orderRequestSubType === CONSTANTS?.PRODUCTION_VEHICLE ? 'production' : 'management' : (isnonStandardequipment ? 'non_standard_eqipment' : 'managed')}`}>
            <Label required className="mb-0" data-attribute="ItemDetail_Default_Label_3_2">PO #</Label>
            <span>{purchaseOrderStepperData?.poNumber ?? "-"}</span>
          </div>
          <div className={`RefreshPurchaseOrderDiv ${isvehiclerequestequipment ? itemDetails.orderRequestSubType === CONSTANTS?.PRODUCTION_VEHICLE ? 'production' : 'management' : (isnonStandardequipment ? 'non_standard_eqipment' : 'managed')}`}>
            {
              (isAuthorized('Refresh_PurchaseOrder') && itemDetails?.canCreatePoPdf) ?
                <EventHandler onEvent={(e: any) => { onClickRefreshPurchaseOrder(e, itemDetails) }} data-attribute="ItemDetail_Default_EventHandler_3">
                  <span id={`view_purchase_order_${itemDetails.itemNumber}`}
                    className='view-purchase-order'
                  >
                    <span className="ReloadIcondiv"><img src={ReloadIcon} alt="reload" /></span>
                    Refresh Purchase Order
                  </span>
                </EventHandler>
                : null
            }
          </div>
          <div className={`sendpo_button ${isvehiclerequestequipment ? itemDetails.orderRequestSubType === CONSTANTS?.PRODUCTION_VEHICLE ? 'production' : 'management' : 'managed'}`}>
            {(itemDetails?.canCreatePoPdf && isAuthorized(permissions.Send_PO_Vendor_Email)) ?
              <EventHandler onEvent={(e: any) => { onClickSendPoToVendor(e, itemDetails) }} data-attribute="ItemDetail_Default_EventHandler_4">
                <PrimaryButton text='Send PO To Vendor' title='Send PO To Vendor'  data-attribute="ItemDetail_Send_PO_To_Vendor_Button" />
              </EventHandler>
              : null}
          </div>
        </> : null}
    </>)
  }

  return (<>
    <div className='item-detail-bottom-block non-standard-equipment'>{isnonStandardequipment && purchaseOrderStepperData?.assetNumber && (purchaseOrderStepperData?.poNumber || purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber')) ? commonFields() : ''}</div>
    <div className={`item-detail-bottom-block ${isnonStandardequipment ? 'non-standard-equipment' : ''}`}>
      {isnonStandardequipment && (
        <div className="unit-price mb-sm-3 mb-3">
          <Label required data-attribute="ItemDetail_Default_Label_4_2">Unit Price</Label>
          <InputField
            placeholder="0.00"
            name="unitPrice"
            onBlur={(event: any) => unitPriceFormat(event.target.value)}
            value={!enableEditNSE ? formatPrice(itemDetails?.poPricePerUnit, 2) : editAssetInfo?.pricePerUnit}
            prefix="$"
            onChange={(item: any) => onChangePrice(item)}
            disabled={(!enableEditNSE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)) ? true : false}
            className={editAssetInfo?.pricePerUnitError?.length > 0 ? 'controlValidation' : ''}
           data-attribute="ItemDetail_unitPrice_Input" />
          {editAssetInfo?.pricePerUnitError?.length > 0 ? <p className='validMessage'>{editAssetInfo?.pricePerUnitError}</p> : null}
        </div>
      )}
      {(ismanagedequipment || isvehiclerequestequipment) && purchaseOrderStepperData?.assetNumber && (purchaseOrderStepperData?.poNumber || purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber')) ? commonFields() : ''}
      {isnonStandardequipment && typeof purchaseOrderStepperData?.hasQuoteAttached === 'boolean' && <div className={`quote-attach ${ismanagedequipment || isvehiclerequestequipment ? (activeStepper == '4' ? 'showCommonFields' : 'notShowCommonFields') : 'showCommonFields'}`}>
        <div className="qutoattach mt-sm-4">
          <Label data-attribute="ItemDetail_Default_Label_5_2">Quote Attached </Label>
          <SwitchToggle checked={purchaseOrderStepperData?.hasQuoteAttached} className="mb-0" disabled={!enableEditNSE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)} onChange={onChnageQuoteAttached}  data-attribute="ItemDetail_Default_SwitchToggle" />
        </div>
      </div>}
      {
        itemDetails?.itemStatus === CONSTANTS?.ITEM_STATUS?.CANCELLED ?
          <div className="cancel-comments">
            <Label data-attribute="ItemDetail_Default_Label_6_2">Cancel Comments</Label>
            <Tooltip content={itemDetails?.cancelComments ?? "-"} data-attribute="ItemDetail_Default_Tooltip_23">
              {itemDetails?.cancelComments ?? "-"}
            </Tooltip>
          </div> : null
      }

      <div className="comment-block">
        <div className='comments_attachmentsblock'>
          <Label className="comments_line" data-attribute="ItemDetail_Default_Label_7_2">Comments</Label>
          <div className="linkAttachmentallign mt-2">


            {isBulkOrder ?
              <div className="bulkorder-linkAttachmentAlign">
                <AttachmentCommonUpload
                  link={true}
                  list={list}
                  uploadedList={uploadedList}
                  setList={setList}
                  multiple={true}
                  uploadBtnClick={onUploadClick}
                  error={attachmentError}
                  setError={setAttachmentError}
                  maxSize={5}
                  onRemove={onRemoveClick}
                  tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                  iAttachmentEditable={true}
                  targetId={`attachements-${itemDetails.itemId?.toString()}`}
                  isDownloadable={false}
                  disabled={isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                 data-attribute="ItemDetail_Default_AttachmentCommonUpload" /></div>
              :
              <>

                {
                  (isAuthorized('View_PurchaseOrder') && itemDetails?.canCreatePoPdf && !purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber') && purchaseOrderStepperData?.assetNumber && purchaseOrderStepperData?.poNumber) ?
                    <EventHandler onEvent={(e: any) => { onClickViewPurchaseOrder(e, itemDetails) }} data-attribute="ItemDetail_Default_EventHandler_5">
                      <span id={`view_purchase_order_${itemDetails.itemNumber}`}
                        className='view-purchase-order view_link'
                      >
                        View Purchase Order
                      </span>
                    </EventHandler>
                    : null
                }

                <span id={`link_attachment_${purchaseOrderStepperData?.itemNumber}`} onClick={(e: any) => { onClicktLinkAttachment(e, purchaseOrderStepperData?.itemNumber - 1) }} className='link-attachment me-0 mb-2'>
                  <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(linkedAttachment)})
                </span>
                {isAttachmentBtnClicked?.[purchaseOrderStepperData?.itemNumber - 1] && (<Callout
                  targetId={`link_attachment_${purchaseOrderStepperData?.itemNumber}`}
                  toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, purchaseOrderStepperData?.itemNumber - 1) }}
                  calloutMaxHeight={300}
                 data-attribute="ItemDetail_Default_Callout">
                  {getAttachmentView(linkedAttachment, purchaseOrderStepperData?.itemNumber - 1)}
                </Callout>)
                }
              </>
            }
          </div>
        </div>
        <InputField
          className={`comments ${errors?.comments ? 'controlValidation' : ""}`}
          name="comment"
          value={purchaseOrderStepperData?.comment}
          onChange={handleChange}
          onBlur={autoSaveComments}
          disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
         data-attribute="ItemDetail_comment_Input" />
        {errors?.comment &&
          <span className="validMessage">"Please enter comment less than 500 characters</span>
        }



      </div>
    </div>
    {showEmailPopup ? (
      <ModalPopup
        ShowModalPopupFooter={true}
        ModalPopupTitle={"Send PO to Vendor"}
        ModalPopupName={"SendPOVendorPopup"}
        ModalPopupType="large"
        FooterSecondaryBtnTxt="Cancel"
        FooterPrimaryBtnTxt="Send Email To Vendor"
        closeModalPopup={hidePopup}
        PrimaryBtnOnclick={(e?: any) => { handleClickTriggerEmail(e, itemDetails) }}
        SecondryBtnOnclick={hidePopup}
       data-attribute="ItemDetail_Default_ModalPopup">
        <SendEmailToVendor
          itemDetails={itemDetails}
          setSendEmailAttachmentsList={setSendEmailAttachmentsList}
          sendEmailAttachmentsList={sendEmailAttachmentsList}
          setSendEmailList={setSendEmailList}
          sendEmailList={sendEmailList}
          emailAttachmentError={emailAttachmentError}
          setEmailAttachmentError={setEmailAttachmentError}
          sendEmailError={sendEmailError}
          setSendEmailerror={setSendEmailerror}
          isEmailSentAlert={isEmailSentAlert}
          dismissMailAlert={dismissMailAlert}
          Popupcontent={Popupcontent}
          hideDialog={hideDialog}
          popupOutlinebtnOnclick={popupOutlinebtnOnclick} />
      </ModalPopup>
    ) : null}
  </>);
};

export default ItemDetail;
